const QUERY_START = '?'
const INDEX_HUMAN_OFFSET = 1

function removeUndefinedFields(item) {
  const curated = Object.entries(item).reduce(
    (acc, [key, value]) => (value === undefined ? acc : { ...acc, [key]: value }),
    {},
  )

  return curated
}

function buildQueryString(queryValues) {
  const queryKeyValues = Object.entries(queryValues)
  const lastIndex = queryKeyValues.length - INDEX_HUMAN_OFFSET

  const queryString = queryKeyValues.reduce((acc, [key, value], index) => {
    const isLastIndex = index === lastIndex
    const currentKeyValuePair = `${key}=${value}${isLastIndex ? '' : '&'}`

    const accQuery = `${acc}${currentKeyValuePair}`

    return accQuery
  }, QUERY_START)

  return queryString
}

export function addQueryString(path, queryValues) {
  const curatedValues = removeUndefinedFields(queryValues)

  const queryString = buildQueryString(curatedValues)

  const fullPath = `${path}${queryString}`

  return fullPath
}
